import InfoCircleIcon from "@redotech/redo-icons/info-circle.svg";
import { memo } from "react";
import {
  RedoBadge,
  type RedoBadgeProps,
} from "../arbiter-components/badge/redo-badge";
import { Tooltip } from "../arbiter-components/tooltip/tooltip";
import { Flex } from "../flex";
import { Text } from "../text";
import * as css from "./settings-rows.module.css";

export interface SettingsRowBadge {
  text: string;
  color?: RedoBadgeProps["color"];
}

/** Left side of a row: title, description, and optional badge or statuses. */
export const SettingsRowLabel = memo(function SettingsRowLabel({
  title,
  description,
  info,
  badge,
  status,
}: {
  title: string;
  description?: string;
  /** Longer help shown on an info icon next to the title. */
  info?: string;
  badge?: SettingsRowBadge;
  status?: SettingsRowBadge | SettingsRowBadge[];
}) {
  const statuses = status ? [status].flat() : [];
  return (
    <Flex className={css.rowLabel} dir="column" gap="xxs">
      <Flex align="center" gap="md">
        <Text fontSize="sm" fontWeight="medium" textColor="primary">
          {title}
        </Text>
        {info && (
          <Tooltip arrow title={info}>
            <span className={css.infoIcon}>
              <InfoCircleIcon />
            </span>
          </Tooltip>
        )}
        {badge && (
          <RedoBadge
            color={badge.color ?? "orange"}
            size="xs"
            text={badge.text}
          />
        )}
      </Flex>
      {(statuses.length > 0 || description) && (
        <Flex align="center" gap="md">
          {statuses.map((badge) => (
            <RedoBadge
              color={badge.color ?? "gray"}
              key={badge.text}
              size="xs"
              text={badge.text}
            />
          ))}
          {description && (
            <Text fontSize="xs" fontWeight="regular" textColor="tertiary">
              {description}
            </Text>
          )}
        </Flex>
      )}
    </Flex>
  );
});
